
function visibilityObserver (onIntersectCb, opts) {
  const options = opts || {}
  const onIntersect = onIntersectCb
  let reportWhenVisible = true

  const ioOpts = {
    root: options.root || null, // null means check against viewport. Else, check against element
    rootMargin: options.rootMargin || '0px',
    threshold: buildThresholdList()
  }

  const observer = new IntersectionObserver(onIntersectCallback, ioOpts)

  function onIntersectCallback (entries, _observer) {
    const intersectionHeight = options.intersectionHeight
    const intersectionRatio = options.intersectionRatio || 0.75

    entries.forEach(entry => {
      if (
        reportWhenVisible === true &&
        entry.isIntersecting &&
        (intersectionHeight
          ? (entry.intersectionRect.height >= intersectionHeight)
          : (entry.intersectionRatio >= intersectionRatio))
      ) {
        reportWhenVisible = false
        onIntersect(entry.target)
        return
      }

      if (entry.rootBounds && (entry.rootBounds.top > entry.intersectionRect.top)) {
        reportWhenVisible = true
      }
    })
  }

  function buildThresholdList () {
    const thresholds = []
    const numSteps = options.steps || 20

    for (let i = 1.0; i <= numSteps; i++) {
      const ratio = i / numSteps
      thresholds.push(ratio)
    }

    thresholds.push(0)
    return thresholds
  }

  function observe (nodeToBeObserved) {
    observer.observe(nodeToBeObserved)
  }

  function unobserve (nodeToBeObserved) {
    observer.unobserve(nodeToBeObserved)
  }

  function disconnect () {
    observer.disconnect()
  }
  return {
    observe,
    unobserve,
    disconnect
  }
}

export default visibilityObserver
